import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { loadingStatus, getPayload } from "actions"
import Modal from "react-responsive-modal"
import fieldStatus from "helpers/fieldStatus"
import submitData from "helpers/submitData"
import { Formik, Field, Form } from "formik"
import fields from "models/landFeature"
import * as Yup from "yup"
import ReactSelect from "components/ReactSelect"
import { toast } from "react-toastify"
import _ from "lodash"
import nulltoEmptyString from "helpers/nullToEmptyString"
import NumberField from "components/NumberField"

class EditLandFeature extends Component {
	constructor(props) {
		super(props)
		this.state = {
			ready: false,
			fields,
			deleteState: false,
		}
	}

	componentDidUpdate(prevProps) {
		if (!_.isEqual(prevProps.data, this.props.data)) {
			let data = _.cloneDeep(this.props.data)
			data = nulltoEmptyString(data)
			this.setState({
				fields: data,
				ready: true,
			})
		}
		return null
	}

	validation = () => {
		return Yup.object().shape({
			name: Yup.string().required("Required"),
			acreage: Yup.number().required("Required"),
			property: Yup.number().required("Required"),
			type: Yup.number().required("Required"),
		})
	}

	submitClasses = (f) => {
		var classNames = require("classnames")
		var submitClasses = classNames("form__submit", {
			"form__submit--ready": f,
		})
		return submitClasses
	}

	options = (f, name) => {
		let ret = []
		_.forEach(this.props.payload.public[name], (v) => {
			if (f.values.property == v.property) {
				ret.push({ label: v.name, value: v.id })
			}
		})
		ret = _.sortBy(ret, "label")
		return ret
	}

	optionsAlpha = (name) => {
		let opts = _.map(this.props.payload.public[name], (v) => {
			return { label: v.name, value: v.id }
		})
		opts = _.sortBy(opts, "label")
		return opts
	}

	deleteFeature = () => {
		if (!this.state.deleteState) {
			this.setState({ deleteState: true })
		} else {
			this.props.loadingStatus(true)
			submitData("mainIngest", { action: "deleteLandFeature", id: this.state.fields.id }).then((data) => {
				this.props.loadingStatus(false)
				this.props.getPayload()
				toast.success(data.message)
				this.props.close()
			})
		}
	}

	render() {
		if (this.props.payloadStatus) {
			const { open } = this.props
			return (
				<div>
					<Modal open={open} onClose={this.props.onClose} center classNames={{ modal: "modalForm" }}>
						<h3>Edit Land Feature</h3>
						<Formik
							enableReinitialize
							initialValues={this.state.fields}
							validationSchema={this.validation}
							onSubmit={(values) => {
								this.props.loadingStatus(true)
								submitData("editLandFeature", values).then((data) => {
									this.props.loadingStatus(false)
									toast.success(data.message)
									this.props.close()
									this.setState(
										{
											redirect: true,
											redirectPath: data.redirect,
										},
										() => {
											this.props.getPayload()
										}
									)
								})
							}}>
							{(f) => (
								<div className="">
									<div className="flex justify-end">
										<div className="mr-14">
											<div
												className="bg-red-500 text-white px-1 py-1 text-xs font-bold cursor-pointer"
												onClick={() => this.deleteFeature()}>
												{this.state.deleteState ? "Confirm Deletion?" : "Delete Feature"}
											</div>
										</div>
									</div>
									<div className="content">
										<Form>
											<ul className="form__list">
												<li className={fieldStatus("name", f)}>
													<label htmlFor="name">
														Name <sup>*</sup>
													</label>
													{f.errors.name && f.touched.name && (
														<div className="form__message">{f.errors.name}</div>
													)}
													<Field name="name" type="text" className="form__input" />
												</li>
												<li className={fieldStatus("property", f)}>
													<label htmlFor="property">
														Property <sup>*</sup>
													</label>
													{f.errors.property && f.touched.property && (
														<div className="form__message">{f.errors.property}</div>
													)}
													<ReactSelect
														name={`property`}
														options={this.optionsAlpha("properties")}
														value={f.values.property}
														onBlur={f.setFieldTouched}
														onChange={f.setFieldValue}
													/>
												</li>
												<li className={fieldStatus("acreage", f)}>
													<label htmlFor="acreage">Acreage</label>
													{f.errors.acreage && f.touched.acreage && (
														<div className="form__message">{f.errors.acreage}</div>
													)}
													<NumberField
														name="acreage"
														type="text"
														className="form__input"
														onChange={f.setFieldValue}
														onBlur={f.setFieldTouched}
														touched={f.touched.acreage}
														value={f.values.acreage}
														thousandSeparator={true}
														decimals={5}
													/>
												</li>
												<li className={fieldStatus("section_id", f)}>
													<label htmlFor="section_id">Section</label>
													<p className="small">If located within a section.</p>
													{f.errors.section_id && f.touched.section_id && (
														<div className="form__message">{f.errors.section_id}</div>
													)}
													<ReactSelect
														name={`section_id`}
														options={this.options(f, "sections")}
														value={f.values.section_id}
														onBlur={f.setFieldTouched}
														onChange={f.setFieldValue}
													/>
												</li>
												{!f.values.section_id ? (
													<li className={fieldStatus("tract", f)}>
														<label htmlFor="tract">Tract</label>
														{f.errors.tract && f.touched.tract && (
															<div className="form__message">{f.errors.tract}</div>
														)}
														<ReactSelect
															name={`tract`}
															options={_.map(
																_.filter(
																	this.props.payload.public.land_tracts,
																	(v) => v.property == f.values.property
																),
																(v) => {
																	return { label: v.name, value: v.id }
																}
															)}
															value={f.values.tract}
															onBlur={f.setFieldTouched}
															onChange={f.setFieldValue}
														/>
													</li>
												) : null}
												<li className={fieldStatus("type", f)}>
													<label htmlFor="type">
														Feature Type <sup>*</sup>
													</label>
													{f.errors.type && f.touched.type && (
														<div className="form__message">{f.errors.type}</div>
													)}
													<ReactSelect
														name={`type`}
														options={this.optionsAlpha("land_feature_types")}
														value={f.values.type}
														onBlur={f.setFieldTouched}
														onChange={f.setFieldValue}
													/>
												</li>
											</ul>
											<input
												type="submit"
												value="Submit"
												className={this.submitClasses(f.isValid)}
											/>
										</Form>
									</div>
								</div>
							)}
						</Formik>
					</Modal>
				</div>
			)
		} else {
			return ""
		}
	}
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
		payloadStatus: state.payloadStatus,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			loadingStatus,
			getPayload,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(EditLandFeature)
